import { render, staticRenderFns } from "./cup3.vue?vue&type=template&id=3b5374fa&scoped=true&"
import script from "./cup3.vue?vue&type=script&lang=js&"
export * from "./cup3.vue?vue&type=script&lang=js&"
import style0 from "./cup3.vue?vue&type=style&index=0&id=3b5374fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5374fa",
  null
  
)

export default component.exports